import * as React from "react";
import PropTypes from "prop-types";
import { Grid, Paper, Box } from "@mui/material";
import Title from "../Title";
import withErrorBoundary from "../withErrorBoundary";

const DetailBlock = React.forwardRef((props, ref) => {
  const { title, titleProps, actions, children, noGrid, sx } = props;

  const innerContent = noGrid ? (
    children
  ) : (
    <Grid container spacing={2}>
      {children}
    </Grid>
  );

  return (
    <Paper sx={{ p: 2, ...sx }} ref={ref}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
        {title && (
          <Title {...titleProps} sx={{ mb: 2, ...titleProps?.sx }}>
            {title}
          </Title>
        )}
        {actions}
      </Box>

      {innerContent}
    </Paper>
  );
});

DetailBlock.displayName = "DetailBlock";
DetailBlock.propTypes = {
  title: Title.propTypes.children,
  titleProps: PropTypes.object,
  actions: PropTypes.node,
  children: PropTypes.node,
  noGrid: PropTypes.bool,
  sx: PropTypes.object,
};

export default withErrorBoundary(DetailBlock);
